"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Tab", {
  enumerable: true,
  get: function () {
    return _Tab.default;
  }
});
Object.defineProperty(exports, "TabContent", {
  enumerable: true,
  get: function () {
    return _TabContent.default;
  }
});
Object.defineProperty(exports, "TabNavigation", {
  enumerable: true,
  get: function () {
    return _TabNavigation.default;
  }
});
Object.defineProperty(exports, "TabPanel", {
  enumerable: true,
  get: function () {
    return _TabPanel.default;
  }
});
Object.defineProperty(exports, "Tabs", {
  enumerable: true,
  get: function () {
    return _Tabs.default;
  }
});
var _Tab = _interopRequireDefault(require("./Tab"));
var _Tabs = _interopRequireDefault(require("./Tabs"));
var _TabPanel = _interopRequireDefault(require("./TabPanel"));
var _TabContent = _interopRequireDefault(require("./TabContent"));
var _TabNavigation = _interopRequireDefault(require("./TabNavigation"));